import { graphql } from "react-relay";

export const QUERY = graphql`
	query appBuildNumber_Query {
		Admin {
			App {
				GetAppBuildNumbers {
					...appBuildNumber_AppVersionFragment
				}
			}
		}
	}
`;

export const APP_VERSION_FRAGMENT = graphql`
	fragment appBuildNumber_AppVersionFragment on AppVersion {
		iosBuildNumber
		androidBuildNumber
	}
`;

export const SET_APP_BUILD_NUMBER_MUTATION = graphql`
	mutation appBuildNumber_setAppBuildNumbersMutation($input: SetAppBuildNumbersInput!) {
		Admin {
			App {
				setAppBuildNumbers(input: $input) {
					appVersion {
						...appBuildNumber_AppVersionFragment
					}
				}
			}
		}
	}
`;
